export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-graph-horizontal-b68a0d404b184ca2693bab7cd3c09503.svg";